import { dedicatedReportsApi } from '../../api/dedicatedReports'
import { DedicatedReportShell, Limitations } from './DedicatedReportShell'
import { FlowTable } from './FlowTable'

/** R3-22 — classifica agenti per pratiche attivate (poi ricavo maturato, se visibile, poi meno storni). */
export function AgentRankingReportPage() {
  return (
    <DedicatedReportShell title="Classifica agenti" icon="leaderboard" load={dedicatedReportsApi.agentRanking}>
      {d => (
        <>
          <div className="text-muted md-typescale-body-small mb-2">Dal {d.period.from} al {d.period.to}.</div>
          <FlowTable first="Agente" rows={d.rows} ranked />
          <Limitations items={d.limitations} />
        </>
      )}
    </DedicatedReportShell>
  )
}
